import {
  frameworkContent as _frameworkContent,
  frameworkContentDe as _frameworkContentDe,
} from './frameworkContent';

export const frameworkContent = _frameworkContent;
export const frameworkContentDe = _frameworkContentDe;

export type FrameworkData = typeof _frameworkContent;

export function getFrameworkSection(
  section: keyof FrameworkData,
  locale: 'en' | 'de' = 'en'
): Record<string, unknown> {
  const data = locale === 'de' ? _frameworkContentDe : _frameworkContent;
  return (data[section] as Record<string, unknown>) || {};
}

export function getAllFrameworkText(locale: 'en' | 'de' = 'en'): string {
  const data = locale === 'de' ? _frameworkContentDe : _frameworkContent;
  const walk = (obj: unknown): string => {
    if (typeof obj === 'string') return obj;
    if (Array.isArray(obj)) return obj.map(walk).join('\n\n');
    if (obj && typeof obj === 'object') {
      return Object.values(obj).map(walk).join('\n\n');
    }
    return '';
  };
  return walk(data);
}
